export const SERVICES = [
  {
    key: "DVBC",
    name: "Dịch vụ Bưu chính chuyển phát",
    values: [
      "BP trong nước",
      "Dịch vụ EMS trong nước",
      "Dịch vụ tiêu chuẩn trong nước",
      "Hàng hóa nhanh đi quốc tế",
      "Hàng hóa tiết kiệm đi quốc tế",
      "Tài liệu nhanh đi quốc tế",
      "Tài liệu tiết kiệm đi quốc tế",
      "Quốc tế chiều đến",
    ],
  },
  {
    key: "TCBC",
    name: "Tài chính bưu chính",
    values: [
      "Dịch vụ Bảo hiểm xã hội Tự nguyện",
      "Dịch vụ Tín dụng Hưu trí",
      "Tiết kiệm bưu điện",
      "Bảo hiểm PTI",
      "Bảo hiểm nhân thọ Daiichi",
      "Dịch vụ thu hộ",
      "Dịch vụ chi hộ",
      "Chuyển tiền",
      "Bảo hiểm y tế hộ gia đình",
    ],
  },
  {
    key: "HCC",
    name: "Hành chính công",
    values: ["Hành chính công"],
  },
  {
    key: "PHBC",
    name: "Phát hành báo chí",
    values: ["Phát hành báo chí"],
  },
  {
    key: "KT1",
    name: "KT1",
    values: ["KT1"],
  },
  {
    key: "PPBL",
    name: "Phân phối bán lẻ",
    values: ["Phân phối bán lẻ"],
  },
];

export const SERVICES_OPTIONS = SERVICES.map((item) => ({
  key: item.key,
  name: item.name,
}));

export const TRANSFER_UNITS = [
  { code: "09", name: "TMĐT Hà Nội" },
  { code: "10", name: "Hà Nội" },
  { code: "16", name: "Hưng Yên" },
  { code: "17", name: "Hải Dương" },
  { code: "18", name: "Hải Phòng" },
  { code: "20", name: "Quảng Ninh" },
  { code: "22", name: "Bắc Ninh" },
  { code: "23", name: "Bắc Giang" },
  { code: "24", name: "Lạng Sơn" },
  { code: "25", name: "Thái Nguyên" },
  { code: "26", name: "Bắc Kạn" },
  { code: "27", name: "Cao Bằng" },
  { code: "28", name: "Vĩnh Phúc" },
  { code: "29", name: "Phú Thọ" },
  { code: "30", name: "Tuyên Quang" },
  { code: "31", name: "Hà Giang" },
  { code: "32", name: "Yên Bái" },
  { code: "33", name: "Lào Cai" },
  { code: "35", name: "Hòa Bình" },
  { code: "36", name: "Sơn La" },
  { code: "38", name: "Điện Biên" },
  { code: "39", name: "Lai Châu" },
  { code: "40", name: "Hà Nam" },
  { code: "41", name: "Thái Bình" },
  { code: "42", name: "Nam Định" },
  { code: "43", name: "Ninh Bình" },
  { code: "44", name: "Thanh Hóa" },
  { code: "46", name: "Nghệ An" },
  { code: "48", name: "Hà Tĩnh" },
  { code: "51", name: "Quảng Bình" },
  { code: "52", name: "Quảng Trị" },
  { code: "53", name: "Huế" },
  { code: "55", name: "Đà Nẵng" },
  { code: "56", name: "Quảng Nam" },
  { code: "57", name: "Quảng Ngãi" },
  { code: "58", name: "Kon Tum" },
  { code: "59", name: "Bình Định" },
  { code: "60", name: "Gia Lai" },
  { code: "62", name: "Phú Yên" },
  { code: "63", name: "Đắc Lắc" },
  { code: "64", name: "Đắk Nông" },
  { code: "65", name: "Khánh Hòa" },
  { code: "66", name: "Ninh Thuận" },
  { code: "67", name: "Lâm Đồng" },
  { code: "70", name: "Hồ Chí Minh" },
  { code: "79", name: "Bà Rịa Vũng Tàu" },
  { code: "80", name: "Bình Thuận" },
  { code: "81", name: "Đồng Nai" },
  { code: "82", name: "Bình Dương" },
  { code: "83", name: "Bình Phước" },
  { code: "84", name: "Tây Ninh" },
  { code: "85", name: "Long An" },
  { code: "86", name: "Tiền Giang" },
  { code: "87", name: "Đồng Tháp" },
  { code: "88", name: "An Giang" },
  { code: "89", name: "Vĩnh Long" },
  { code: "90", name: "Cần Thơ" },
  { code: "91", name: "Hậu Giang" },
  { code: "92", name: "Kiên Giang" },
  { code: "93", name: "Bến Tre" },
  { code: "94", name: "Trà Vinh" },
  { code: "95", name: "Sóc Trăng" },
  { code: "96", name: "Bạc Liêu" },
  { code: "97", name: "Cà Mau" },
];

export const WIDTH_RESIZE = 1700;
export const HEIGHT_RESIZE = 700;
export const FONT_SIZE_DEFAULT = 16;
export const FONT_SIZE_SMALL = 14;
export const FONT_SIZE_TABLE = 14;
